import { LandingHeader } from '@modules/Landing/Components/MobileLanding/LandingHeader/LandingHeader';
import bannerImg from '@assets/Imgs/LandingBanners/landingBannerMobile.svg';
import css from './MobileLanding.module.css';
import FAQSection from '@shared/Features/FAQSection/FAQSection';
import { MobileLandingGifsSection } from '@shared/Features/MobileLandingGifsSection/MobileLandingGifsSection';
import { LandingTemplatesSection } from '@modules/Landing/Components/MobileLanding/LandingTemplatesSection/LandingTemplatesSection';
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { ShimmerLoader } from '@shared/Ui/Loaders/ShimmerLoader/ShimmerLoader';

export const MobileLanding: React.FC = () => {
    const [bannerUrl, setBannerUrl] = useState<string>('');

    useEffect(() => {
        const loadBanner = async () => {
            try {
                const module = await import(
                    '@assets/Imgs/LandingBanners/landingBannerMobile.png'
                );
                setBannerUrl(module.default);
            } catch (error) {
                setBannerUrl('');
            }
        };
        loadBanner();
    }, []);

    return (
        <section className={css.section}>
            <LandingHeader />
            <div className={css.bannerWrapper}>
                {!bannerUrl ? (
                    <ShimmerLoader>
                        <div
                            className={classNames(css.bannerPlaceholder, {
                                [css.transparent]: bannerUrl,
                            })}
                        />
                    </ShimmerLoader>
                ) : (
                    <div className={css.bannerImgWrapper}>
                        <img
                            src={bannerUrl}
                            className={css.banner}
                            alt="banner"
                        />
                    </div>
                )}
            </div>
            <MobileLandingGifsSection />
            <LandingTemplatesSection />
            <FAQSection />
        </section>
    );
};
